interface ISocialMediaIcon {
  imgSrc: string;
  imgAltText: string;
  url: string;
}
function SocialMediaIcon({ imgSrc, imgAltText, url }: ISocialMediaIcon) {
  return (
    <a
      className="flex  justify-center items-center transition-all hover:border-green-500 hover:scale-110"
      href={url}
      target="_blank"
      rel="noreferrer"
    >
      <img
        src={imgSrc}
        alt={imgAltText}
        className=" h-8 w-8 grayscale hover:scale-110 transition-all"
      />
    </a>
  );
}

export default SocialMediaIcon;
